import { CanActivateFn } from "@angular/router";
import { AuthenticationManager } from "../../shared/services/authentication-manager";
import { inject } from "@angular/core";
import { catchError, of, tap } from "rxjs";
import { NavigationService } from "../../shared/services/navigation.service";

export const authenticatedGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthenticationManager);
    const navigation = inject(NavigationService);
    return authService.userLoggedIn().pipe(
        catchError(_ => {
            return of(false);
        }),
        tap(loggedIn => {
            if (!loggedIn) {
                const returnUrl = state.url;
                navigation.navigateToLogin(returnUrl);
            }
        })
    );
};